import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getCurrentUser } from "@aws-amplify/auth";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";

export default function EditUserDataModal({
  open,
  setOpen,
  setNotificationMessage,
  setOpenNotification,
}) {
  const { t } = useTranslation();

  const emptyNewUser = {
    email: "",
    given_name: "",
    family_name: "",
    phone_number: "",
  };

  const [updatedUser, setUpdatedUser] = React.useState(emptyNewUser);

  React.useEffect(() => {
    getUser();
  }, []);

  async function getUser() {
    const user = await getCurrentUser();
    const { attributes } = user;
    setUpdatedUser(attributes);
  }

  function handleNewUserChange(event, key) {
    setUpdatedUser({
      ...updatedUser,
      [key]: event.target.value,
    });
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    borderRadius: 5,
    boxShadow: 24,
    pb: 4,
    pt: 1,
  };

  const textFieldSx = { width: 400, mb: 2 };

  async function updateUserAttributes() {
    try {
      const user = await getCurrentUser();
      await updateUserAttributes(user, {
        email: updatedUser.email,
        given_name: updatedUser.given_name || "",
        family_name: updatedUser.family_name || "",
        phone_number: updatedUser.phone_number || "",
      });
      window.location.reload(false);
      setNotificationMessage(t("userDataChangeSuccess"));
    } catch (err) {
      setNotificationMessage(t("errorMessage"));
    }
    setOpenNotification(true);
  }

  return (
    <div>
      <Modal
        open={open}
        //onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableAutoFocus={true}
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              color="secondary"
              aria-label="add an alarm"
              sx={{ mr: 1 }}
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: 1,
            }}
          >
            <Typography sx={{ fontSize: 18, userSelect: "none" }}>
              {t("editOwnData")}
            </Typography>
            <Divider flexItem sx={{ mb: 4, mt: 1 }} />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label="E-Mail"
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={updatedUser.email}
              onChange={(event) => handleNewUserChange(event, "email")}
              helperText={t("invalidMail")}
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={t("prename")}
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={updatedUser.given_name}
              onChange={(event) => handleNewUserChange(event, "given_name")}
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={t("surname")}
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={updatedUser.family_name}
              onChange={(event) => handleNewUserChange(event, "family_name")}
            />
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={t("mobile")}
              variant="outlined"
              size="small"
              sx={textFieldSx}
              value={updatedUser.phone_number}
              onChange={(event) => handleNewUserChange(event, "phone_number")}
              helperText={t("phoneFormat")}
            />
            <Button
              sx={{ mt: 1 }}
              color="secondary"
              variant="contained"
              size="small"
              onClick={() => {
                updateUserAttributes();
                setOpen(false);
              }}
            >
              {t("updateData")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
